import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Cold-start resilience: after inactivity the production origin can take a
// while to wake up and the CDN returns 5xx/empty responses. Retry safe
// requests automatically with backoff instead of surfacing raw CDN errors.
export const COLD_START_STATUSES = [502, 503, 504, 520, 521, 522, 523, 524, 525, 526];
const RETRY_DELAYS = [1500, 3000, 6000, 10000];

const isRetryable = (err) => {
  const cfg = err?.config;
  if (!cfg) return false;
  const method = (cfg.method || "get").toLowerCase();
  const safe = method === "get" || method === "head" || cfg.__retryAllowed;
  if (!safe) return false;
  if (!err.response) return err.code !== "ERR_CANCELED";
  return COLD_START_STATUSES.includes(err.response.status);
};

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err?.config;
    if (isRetryable(err)) {
      const n = cfg.__retryCount || 0;
      if (n < RETRY_DELAYS.length) {
        cfg.__retryCount = n + 1;
        if (typeof cfg.__onRetry === "function") cfg.__onRetry(n + 1, RETRY_DELAYS.length);
        await new Promise((res) => setTimeout(res, RETRY_DELAYS[n]));
        return api(cfg);
      }
      err.__coldStart = true;
    }
    return Promise.reject(err);
  },
);

// Fire-and-forget ping that wakes a sleeping origin as soon as the app opens.
export const warmUp = () => api.get("/", { timeout: 20000 }).catch(() => {});

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;
